import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor"]
  static values = { 
    quoteId: String,
    contractType: String,
    modelType: String,
    placeholders: Array
  }

  connect() {
    // Controller verbunden
  }



  insertPlaceholder(event) {
    // Verhindere Form-Submit
    event.preventDefault()
    event.stopPropagation()
    
    const placeholderKey = event.target.dataset.placeholder
    
    // Verwende das Editor Target
    const editor = this.editorTarget
    
    if (!editor) {
      alert('Bitte öffnen Sie zuerst den Editor, um Platzhalter einzufügen.')
      return
    }

    const placeholder = `{{ ${placeholderKey} }}`
    
    // Fokussiere den Editor
    editor.focus()
    
    // Warte bis der Editor bereit ist
    setTimeout(() => {
      if (editor.editor) {
        try {
          // Füge an der aktuellen Cursor-Position ein
          editor.editor.insertHTML(placeholder)
          
          // Trigger change event damit Trix erkennt dass sich der Inhalt geändert hat
          editor.dispatchEvent(new Event('trix-change', { bubbles: true }))
        } catch (error) {
          // Fallback: Direktes Setzen des Values
          const currentValue = editor.value || ''
          editor.value = currentValue + placeholder
          editor.dispatchEvent(new Event('trix-change', { bubbles: true }))
        }
      } else {
        // Fallback: Direktes Setzen des Values
        const currentValue = editor.value || ''
        editor.value = currentValue + placeholder
        editor.dispatchEvent(new Event('trix-change', { bubbles: true }))
      }
    }, 100)
  }

}
